( function ( _s ) {
	_s.fn.learnDashRegisterProfile = function () {
		return this.each( el => {
			const _self = _s( el );
			const queryString = window.location.search;
			const urlParams = new URLSearchParams( queryString );
			const _emailField = _self.find( '[name="user_email"]' );
			let _confirmEmailField = false;
			const _username = _self.find( '[name="user_login"]' );
			const emailParam = urlParams.get( 'user_email' );
			const _passwordField = _self.find( '[name="password"]' );
			const _confirmPasswordField = _self.find( '[name="confirm_password"]' );
			const _companyZipCodeField = _self.find( '[name="company_zip_code"]' );
			const _companyPhoneNumberField = _self.find( '[name="company_phone_number"]' );
			let _requiredFields = [];
			let errorsList = [];

			const setRequiredFields = () => {
				_requiredFields = _self
					.find( '.learndash-required' )
					.find(
						'[type="text"], [type="email"], [type="tel"], [type="password"], select'
					);
			};

			const addErrorToList = ( fieldName, errorMessage ) => {
				errorsList.push( {
					invalid_field: fieldName,
					error_message: errorMessage,
				} );
			};

			const addErrorMessages = () => {
				errorsList.forEach( error => {
					let _invalidField = _s( `[name="${ error.invalid_field }"]` );

					if ( _invalidField.length ) {
						if ( _invalidField.firstElement().tagName.toLowerCase() === 'select' ) {
							_invalidField = _s(
								`.ss-main[data-id="${ _invalidField.attr( 'data-id' ) }"]`
							);
						}
						if ( _invalidField.length ) {
							_invalidField.after(
								`<span class="error-message">${ error.error_message }</span>`
							);
						}
					}
				} );
			};

			const getFieldLabel = fieldName => {
				let fieldLabel = '';

				if ( _self.filter( '#learndash_registerform' ).length ) {
					fieldLabel = _s( `[name="${ fieldName }"]` )
						.closest( '.learndash-registration-field' )
						.find( `> label` )
						.text();
				} else {
					const fieldClone = _s( `[name="${ fieldName }"]` )
						.parent()
						.firstElement()
						.cloneNode( true );
					const _fieldClone = _s( fieldClone );

					_fieldClone.find( '> *' ).remove();

					fieldLabel = _fieldClone.text();
				}

				//fieldLabel = fieldLabel.replace( ' *', '' );
				fieldLabel = fieldLabel.replace( '*', '' );

				return fieldLabel.trim();
			};

			const validateFields = () => {
				let validRequired = true;
				let validEmails = true;
				let validPassword = true;
				let validPasswordConfirmation = true;
				let validZipCode = true;
				let validPhoneNumber = true;
				let validForm = true;
				errorsList = [];

				_self.find( '[aria-invalid]' ).attr( 'aria-invalid', false );
				_self.find( 'span.error-message' ).remove();

				validRequired = validateRequiredFields();

				if ( _self.filter( '#learndash_registerform' ).length ) {
					validEmails = validateEmailFields();
					validPassword = validatePassword();
					validPasswordConfirmation = validatePasswordConfirmation();
				}

				validZipCode = validateZipCode();

				validPhoneNumber = validatePhoneNumber();

				validForm =
					validEmails === true &&
					validPassword === true &&
					validPasswordConfirmation === true &&
					validZipCode === true &&
					validPhoneNumber === true &&
					validRequired === true;

				if ( ! validForm ) {
					addErrorMessages();
				}

				return validForm;
			};

			const validateRequiredFields = () => {
				let valid = true;

				_requiredFields.each( field => {
					if ( field.value.length === 0 ) {
						field.setAttribute( 'aria-invalid', 'true' );
						valid = false;

						addErrorToList( `${ _s( field ).attr( 'name' ) }`, 'Required field' );

						if ( field.tagName.toLowerCase() === 'select' ) {
							const _slimSelectDropdown = _s(
								`.ss-main[data-id="${ _s( field ).attr( 'data-id' ) }"]`
							);

							_slimSelectDropdown.each( dropdown => {
								dropdown.setAttribute( 'aria-invalid', 'true' );
							} );
						}
					}
				} );

				return valid;
			};

			const validateEmailFields = () => {
				let valid = true;
				const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

				_self.filter( '#learndash_registerform' ).each( () => {
					if (
						_emailField.length &&
						_emailField.firstElement().value.length > 0 &&
						! emailPattern.test( _emailField.firstElement().value )
					) {
						valid = false;
						addErrorToList(
							`${ _emailField.attr( 'name' ) }`,
							'Email address is not valid'
						);
						_emailField.firstElement().setAttribute( 'aria-invalid', 'true' );
					}

					if (
						_confirmEmailField &&
						_confirmEmailField.length &&
						_confirmEmailField.firstElement().value.length > 0 &&
						! emailPattern.test( _confirmEmailField.firstElement().value )
					) {
						valid = false;
						addErrorToList(
							`${ _confirmEmailField.attr( 'name' ) }`,
							'Email address is not valid'
						);
						_confirmEmailField.firstElement().setAttribute( 'aria-invalid', 'true' );
					}

					if (
						_emailField.length &&
						_confirmEmailField &&
						_confirmEmailField.length &&
						_emailField.firstElement().value.length > 0 &&
						_confirmEmailField.firstElement().value.length > 0 &&
						_emailField.firstElement().value !== _confirmEmailField.firstElement().value
					) {
						valid = false;
						addErrorToList(
							`${ _confirmEmailField.attr( 'name' ) }`,
							'Email addresses do not match'
						);
						_confirmEmailField.firstElement().setAttribute( 'aria-invalid', 'true' );
					}
				} );

				return valid;
			};

			const validatePassword = () => {
				let valid = true;
				const regex =
					/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

				if (
					_passwordField.length &&
					_passwordField.firstElement().value.length > 0 &&
					! regex.test( _passwordField.firstElement().value )
				) {
					valid = false;
					addErrorToList(
						`${ _passwordField.attr( 'name' ) }`,
						'Password does not meet the minimum requirements'
					);
					_passwordField.firstElement().setAttribute( 'aria-invalid', 'true' );
				}

				return valid;
			};

			const validatePasswordConfirmation = () => {
				let valid = true;

				if ( _passwordField.length && _confirmPasswordField.length ) {
					if (
						_passwordField.firstElement().value.length > 0 &&
						_confirmPasswordField.firstElement().value.length > 0 &&
						_passwordField.firstElement().value !==
							_confirmPasswordField.firstElement().value
					) {
						valid = false;
						addErrorToList(
							`${ _confirmPasswordField.attr( 'name' ) }`,
							'Passwords do not match'
						);
						_confirmPasswordField.firstElement().setAttribute( 'aria-invalid', 'true' );
					}
				}

				return valid;
			};

			const validateZipCode = () => {
				let valid = true;
				const pattern = /^\d{5}$/;
				const zipCode = _companyZipCodeField.length
					? _companyZipCodeField.firstElement().value
					: false;

				if ( zipCode && ! pattern.test( zipCode ) ) {
					valid = false;
					addErrorToList(
						`${ _companyZipCodeField.attr( 'name' ) }`,
						'Enter a 5-digit Zip code'
					);
					_companyZipCodeField.firstElement().setAttribute( 'aria-invalid', 'true' );
				}

				return valid;
			};

			const validatePhoneNumber = () => {
				let valid = true;
				const pattern = /^\d+$/;
				const phoneNumber = _companyPhoneNumberField.length
					? _companyPhoneNumberField.firstElement().value
					: false;

				if ( phoneNumber && ! pattern.test( phoneNumber ) ) {
					valid = false;
					addErrorToList(
						`${ _companyPhoneNumberField.attr( 'name' ) }`,
						'Only digits allowed'
					);
					_companyPhoneNumberField.firstElement().setAttribute( 'aria-invalid', 'true' );
				}

				return valid;
			};

			const addErrorAlert = () => {
				_self.find( '.error-alert' ).remove();

				let errorAlertList = '';

				errorsList.forEach( error => {
					const fieldLabel = getFieldLabel( error.invalid_field );
					errorAlertList += `<span><b>${ fieldLabel }:</b> ${ error.error_message }</span>`;
				} );

				_self.prepend(
					`<p class="error-alert fr-alert error has-error-list">
                        Please correct any invalid or missing information:
                        <span class="error-list">
                            ${ errorAlertList }
                        </span>
                    </p>`
				);
			};

			const removeErrorAlert = () => {
				_requiredFields.removeAttr( 'aria-invalid' );
				_self.find( '.error-alert' ).remove();
			};

			const checkErrors = () => {
				if ( _self.find( '[aria-invalid="true"]' ).length ) {
					addErrorAlert();
				} else {
					removeErrorAlert();
				}
			};

			const setUsername = () => {
				if ( _username.firstElement() && _emailField.firstElement() ) {
					const emailValue = _emailField
						.firstElement()
						.value.replace( /[^a-zA-Z0-9]/g, '_' );

					_username.firstElement().value = emailValue + Date.now();
				}
			};

			/** For registration form exclusively */
			if ( _self.filter( '#learndash_registerform' ).length ) {
				/** Position "confirm email" field right below email field */
				_self.find( '.learndash-registration-field-confirm-email' ).each( field => {
					const _field = _s( field );

					_emailField
						.closest( '.learndash-registration-field' )
						.after( _field.firstElement() );

					_field.remove();

					_s( '.learndash-registration-field-confirm-email [name="confirm_email"]' ).each(
						confirmEmail => {
							_confirmEmailField = _s( confirmEmail );
						}
					);
				} );

				if ( _passwordField.length ) {
					_passwordField.after(
						'<span class="note">The password should be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and a special character (!@#$%^&*).</span>'
					);
				}

				if ( emailParam ) {
					_emailField.firstElement().value = emailParam.replace( / /g, '+' );
				}

				setUsername();

				_emailField.on( 'change', function () {
					setUsername();
				} );

				/** Move first and last name to the beginning */
				_self.find( '.learndash-registration-field-last_name' ).each( element => {
					_self.prepend( element );
					_s( element ).remove();
				} );

				_self.find( '.learndash-registration-field-first_name' ).each( element => {
					_self.prepend( element );
					_s( element ).remove();
				} );

				/** Move first and last name to the same row */
				_self
					.find(
						'.learndash-registration-field-first_name, .learndash-registration-field-last_name'
					)
					.wrapAll( '<div class="fields-row"></div>' );
			}

			setRequiredFields();

			/**
			 * Fix LearnDash bug that adds extra double quotes to 'aria-required' attribute
			 */
			if ( _requiredFields.length ) {
				_requiredFields.each( field => {
					if ( _s( field ).attr( 'aria-required' ) === `"true"` ) {
						_s( field ).attr( 'aria-required', 'true' );
					}
				} );
			}

			/**
			 * Add or remove aria-invalid attribute based on current field values
			 */
			if ( _requiredFields.length ) {
				_requiredFields.on( 'blur', () => {
					if ( _self.find( '[aria-invalid="true"]' ).length ) {
						validateFields();

						checkErrors();
					}
				} );
			}

			/**
			 * Add or remove aria-invalid attribute based on current dropdown values
			 */
			_requiredFields.filter( 'select' ).on( 'change', () => {
				// if ( _s( e.target ).attr( 'aria-invalid' ) === 'true' ) {
				if ( _self.find( '[aria-invalid="true"]' ).length ) {
					validateFields();

					checkErrors();
				}
			} );

			_self.on( 'submit', e => {
				if ( ! validateFields() ) {
					e.preventDefault();
					addErrorAlert();
					window.scrollTo( 0, 0 );
				} else {
					removeErrorAlert();
				}
			} );

			_self.addClass( 'show-form' );
		} );
	};

	_s( document ).ready( () => {
		_s(
			'#learndash_registerform, .learndash-edit-profile-form form'
		).learnDashRegisterProfile();
	} );
} )( window._s );
